export default __webpack_public_path__ + "media/images/default-user-d17fb72f.png";